module.exports = __webpack_public_path__ + "static/media/Dr. Xiao Feng.fad5c1c4.png";